import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "panel custom-fields-panel p-bottom-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "panel-heading has-background-light has-text-weight-semibold is-size-4" }, " Additional information ", -1)
const _hoisted_3 = {
  key: 0,
  class: "panel-content"
}
const _hoisted_4 = { class: "has-text-weight-semibold" }
const _hoisted_5 = { class: "panel-item" }
const _hoisted_6 = { class: "m-left-8 m-bottom-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "is-italic"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrLoadingAnimation = _resolveComponent("NrLoadingAnimation")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    (!_ctx.filteredRequestLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.slug,
              class: "panel-content-section"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", {
            'panel-item--editable': _ctx.$can('manage', 'Request')
          }])
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(field.label), 1),
                (_ctx.$can('manage', 'Request'))
                  ? (_openBlock(), _createBlock(_component_NrTooltip, {
                      key: 0,
                      label: "Edit"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_NrIconButton, {
                          variant: "minimal-neutral",
                          icon: { name: 'pencil-alt', type: 'regular' },
                          "aria-label": `Edit: ${field.label}`,
                          onClick: ($event: any) => (_ctx.handleEditField(field.slug))
                        }, null, 8, ["aria-label", "onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, [
                  (!!field.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(field.value), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "No data entered"))
                ])
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_NrLoadingAnimation, {
          key: 1,
          count: 3
        })),
    _createVNode(_component_NrModal, {
      title: "Edit additional information",
      secondaryButtonText: "Cancel",
      primaryButtonText: "Update information",
      hasSecondaryButton: true,
      show: _ctx.showModal,
      onOnCloseClick: _ctx.handleCloseModal,
      onOnSecondaryClick: _ctx.handleCloseModal,
      onOnPrimaryClick: _ctx.handleUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createElementVNode("fieldset", null, [
            _createVNode(_component_NrFormInput, {
              id: "custom-field",
              label: _ctx.tmp.label,
              modelValue: _ctx.tmp.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tmp.value) = $event))
            }, null, 8, ["label", "modelValue"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "onOnCloseClick", "onOnSecondaryClick", "onOnPrimaryClick"])
  ]))
}